module.exports = __webpack_public_path__ + "static/media/img01.7518c737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/02/assets/img01.jpg
// module id = 354
// module chunks = 0